import { Box, Button, FormLabel, Heading, Input, Stack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainModel from "../../../../components/Models/main-model";
import { 
  closeCreateTeacherAdmin,
  openShowTeacherAdminDataModel,
} from "../../../../modules/admin-modules/models/Actions";
import { getAllCoursesRequest } from "../../../../modules/superadmin-modules/courses/Actions";
import { addTeacherAdminRequest } from "../../../../modules/superadmin-modules/teachers/Actions";
import ShowTeacherAdminData from "./show-teacher-admin-data";

const AddTeacherAdmin = ({ isAdd, data, setSelectedData, setAddedTeacherAdmin }) => {
  const openTeacherAdmin = useSelector((state) => state.model.isOpen38);
  const courses = useSelector((state) => state.courses.courses);
  const isLoading = useSelector((state) => state.courses.isLoading);
  const dispatch = useDispatch();
  const [teacherAdminData, setTeacherAdminData] = useState({});

  const coursesOptions = courses?.map((course) => {
    return { value: course.id, label: course.name };
  });

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  useEffect(() => {
    if (openTeacherAdmin) {
      dispatch(getAllCoursesRequest());
    }
  }, [openTeacherAdmin]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? "إضافة معلم إداري" : "تعديل معلم إداري"}
      </Heading>
    </Box>
  );

  const onSubmit = (values) => {
    console.log("Form submitted with values:", values);
    let formData = new FormData();
    const total = { ...data, ...values };
    for (let key in total) {
      formData.append(key, total[key]);
    }
    const action = (responseData) => {
      dispatch(closeCreateTeacherAdmin());
      setAddedTeacherAdmin(responseData);
      setTeacherAdminData(responseData);
      dispatch(openShowTeacherAdminDataModel());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      dispatch(addTeacherAdminRequest(formData, action));
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateTeacherAdmin());
    setSelectedData({});
    reset();
  };

  return (
    <>
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openTeacherAdmin}
      buttonTitle={isAdd ? "إضافة معلم إداري" : "تعديل معلم إداري"}
      buttonFunc={handleSubmit(onSubmit)}
    >
        <Stack spacing={5} dir="rtl" w="100%">
          <Box w="55%">
            <FormLabel>الاسم : </FormLabel>
            <Input
              type={"text"}
              borderColor={errors?.name?.message ? "red" : "gray.200"}
              placeholder={"ادخل الاسم"}
              size="md"
              bg="#f5f5f5"
              defaultValue={data?.name}
              _focus={{ outline: "none" }}
              {...register("name", { required: "هذه المعلومات مطلوبة" })}
            />
          </Box>

          <Box w="55%">
            <FormLabel>رقم الهاتف : </FormLabel>
            <Input
              type={"tel"}
              borderColor={errors?.phone?.message ? "red" : "gray.200"}
              placeholder={"ادخل رقم الهاتف"}
              size="md"
              bg="#f5f5f5"
              defaultValue={data?.phone}
              _focus={{ outline: "none" }}
              {...register("phone", { required: "هذه المعلومات مطلوبة" })}
            />
          </Box>

          <Box w="55%">
            <FormLabel>الكورس : </FormLabel>
            <Select
              options={coursesOptions}
              defaultValue={{
                label: data?.course?.name,
                value: data?.course?.id,
              }}
              onChange={(data) => setValue("course_id", data.value)}
              styles={colourStyles}
              placeholder="اختر الكورس"
              name="course_id"
            />
          </Box>
        </Stack>
    </MainModel>
      <ShowTeacherAdminData data={teacherAdminData} />
    </>
    
  );
};

export default AddTeacherAdmin;
